var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("profilesPage.profiles_title") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              [
                _c(
                  "b-row",
                  { staticClass: "justify-content-center" },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "mt-3",
                        attrs: { cols: "12", lg: "11", xl: "10" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "outline-content" },
                          [
                            _c(
                              "form-accordion",
                              {
                                staticClass: "ml-3 mr-3",
                                attrs: {
                                  title: _vm.$t(
                                    "administration.company_details"
                                  ),
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "ml-5 mt-4 mb-4 mr-5 mr-5 form-group",
                                  },
                                  [
                                    _vm.accountLogin
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.idtfr"),
                                                inputValue: _vm.accountLogin
                                                  ? _vm.accountLogin
                                                  : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.accountEmailReference
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.eml"),
                                                inputValue:
                                                  _vm.accountEmailReference
                                                    ? _vm.accountEmailReference
                                                    : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "ml-5 mb-4 mr-5 mr-5 form-group",
                                  },
                                  [
                                    _vm.accountName
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.nme"),
                                                inputValue: _vm.accountName
                                                  ? _vm.accountName
                                                  : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.accountAddress
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.adrs"),
                                                inputValue: _vm.accountAddress
                                                  ? _vm.accountAddress
                                                  : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "ml-5 mb-4 mr-5 mr-5 form-group",
                                  },
                                  [
                                    _vm.accountCity
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.cty"),
                                                inputValue: _vm.accountCity
                                                  ? _vm.accountCity
                                                  : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.accountZipCode
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.zp_code"),
                                                inputValue: _vm.accountZipCode
                                                  ? _vm.accountZipCode
                                                  : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "ml-5 mb-4 mr-5 mr-5 form-group",
                                  },
                                  [
                                    _vm.accountCountry
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.ctry"),
                                                inputValue: _vm.accountCountry,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.accountType === "1" &&
                                    _vm.accountLegalForm
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.lgl_frm"),
                                                inputValue:
                                                  _vm.accountLegalForm,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "ml-5 mb-4 mr-5 mr-5 form-group",
                                  },
                                  [
                                    _vm.accountType === "1" &&
                                    _vm.accountAmountOfCapital
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.shr_cptl"),
                                                inputValue:
                                                  _vm.accountAmountOfCapital,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.accountType === "1" &&
                                    _vm.accountIdentifierTVA
                                      ? _c(
                                          "b-col",
                                          { attrs: { sm: "5" } },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.tva_nbr"),
                                                inputValue:
                                                  _vm.accountIdentifierTVA,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "form-accordion",
                              {
                                staticClass: "ml-3 mr-3",
                                attrs: {
                                  title: _vm.$t("administration.user_details"),
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "ml-5 mt-4 mb-4 mr-5 mr-5 form-group",
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "5" } },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t(
                                              "administration.login"
                                            ),
                                            inputValue: _vm.userLogin
                                              ? _vm.userLogin
                                              : "-",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "5" } },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t("common.nme"),
                                            inputValue: _vm.userName
                                              ? _vm.userName
                                              : "-",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              {
                                staticClass:
                                  "form-group justify-content-end mr-5",
                              },
                              [
                                _vm.hasRight("change_password")
                                  ? _c(
                                      "div",
                                      { attrs: { sm: "2" } },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              variant: "primary",
                                              size: "lg",
                                            },
                                            on: { click: _vm.changePassword },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa-light fa-gear",
                                              attrs: { size: "17px" },
                                            }),
                                            _vm._v(" "),
                                            _vm.displayChangerPassword
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("common.chg_pwd")
                                                    )
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("common.def_pwd")
                                                    )
                                                  ),
                                                ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }